import { render } from "./PunishmentEntry.vue?vue&type=template&id=d7df0604&scoped=true&ts=true"
import script from "./PunishmentEntry.vue?vue&type=script&lang=ts"
export * from "./PunishmentEntry.vue?vue&type=script&lang=ts"

import "./PunishmentEntry.vue?vue&type=style&index=0&id=d7df0604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7df0604"]])

export default __exports__